import React from 'react';
import img1 from '../../asset/img/23324.jpg'
// import { AiFillLinkedin, AiFillFacebook, AiFillGithub } from 'react-icons/ai';
import { VscFilePdf } from 'react-icons/vsc';

const Hero = () => {
    return (
        <div className="hero h-[650px] lg:place-items-start" style={{ backgroundImage: `url(${img1})` }}>
            <div className="hero-overlay  bg-opacity-50"></div>
            <div className="hero-content text-neutral-content justify-end">
                <div className="max-w-md lg:mt-44 lg:ml-20">
                    <h1 className="mb-1 text-4xl font-bold text-white">Muhammad Iftakhar</h1>
                    <h1 className="mb-4 text-2xl font-semibold text-white">Front-end web developer</h1>
                    <p className="mb-4 text-white">A successful website does three things: <br></br>
                        It attracts the right kinds of visitors.<br></br>
                        Guides them to the main services or product you offer.<br></br>
                        Collects contact details for future ongoing relations.</p>
                    <a rel="noreferrer" target='_blank' href='https://drive.google.com/file/d/1YTcrZGc3QIJW8t5z8r8N-V9AlA5aH7OT/view?usp=share_link'> <button className="bg-gradient-to-r from-transparent  to-slate-900 rounded  border-amber-900 p-2 text-orange-300 flex items-center gap-1"><span><VscFilePdf></VscFilePdf></span> Resume</button></a>
                </div>

            </div>
            {/* <div className=' grid gap-y-4 z-10'>
                <AiFillLinkedin className=' w-5 h-5 hover:text-amber-500'></AiFillLinkedin>
                <AiFillFacebook className=' w-5 h-5 hover:text-amber-500'></AiFillFacebook>
                <AiFillGithub className=' w-5 h-5 hover:text-amber-500'></AiFillGithub>
                {/* <hr size="40" width="1px" className=' h-10' color="black" /> */}
            {/* </div> */}
        </div>
    );
};

export default Hero;